/* ============================================================
   TWRD cart drawer v2: drawer script.
   Moved from the inline <script> in snippets/twrd-cart-drawer-v2.liquid
   (perf C7). Loaded with a plain blocking <script src> at the same place,
   so it runs at the same point in the parse as before. The only change:
   TAX_NOTE, DUTY_NOTE and WITHDRAWAL_MARKET are read from data attributes.
   ============================================================ */
  (function () {
    'use strict';
    if (window.__twrdCartDrawerV2) return;
    window.__twrdCartDrawerV2 = true;

    /* Market values come from Liquid in snippets/twrd-cart-drawer-v2.liquid,
       as data attributes on the script tag that loads this file. */
    var CFG_EL = document.currentScript || document.querySelector('script[data-twrd-cdv2-cfg]');
    function cfgAttr(name) {
      var v = CFG_EL ? CFG_EL.getAttribute(name) : null;
      return v == null ? '' : v;
    }

    var TAX_NOTE = cfgAttr('data-tax-note');
    var DUTY_NOTE = cfgAttr('data-duty-note');
    var REC_TITLE = 'You might also wear';

    /* TWRD 2026-10-14 legal: the returns row only where the right of
       withdrawal applies (EU, EEA, UK). The delivery value is set live by
       shipValue(): "Free" only over the free-shipping threshold. */
    var WITHDRAWAL_MARKET = cfgAttr('data-withdrawal') === 'true';
    var CFG = {
      title: 'Bag',
      values: (WITHDRAWAL_MARKET ? [['14-day EU returns', 'Your right']] : []).concat([
        ['Tracked delivery', '', 'ship'],
        ['Made to order for you', 'Free']
      ])
    };

    var TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2" y="6" width="13" height="10" rx="1"/><path d="M15 9h4l3 4v3h-7"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>';
    var TAG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9-9-9Z"/><circle cx="7.5" cy="7.5" r="1.2"/></svg>';
    var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 13 4.5 4.5L19 7"/></svg>';

    function root() { return document.querySelector('#modal-cart'); }

    /* Modalens overflow-lock fjerner scrollbarens bredde. Bevar kroppens
       eksisterende hoejre-padding og laeg kun forskellen til under cart. */
    var bodyPadding = null;
    var cartModal = root();
    if (cartModal) {
      cartModal.addEventListener('on:modal:opening', function () {
        if (bodyPadding !== null) return;
        bodyPadding = document.body.style.paddingRight;
        var gap = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        if (gap) {
          var current = parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
          document.body.style.paddingRight = (current + gap) + 'px';
        }
      });
      cartModal.addEventListener('on:modal:closed', function () {
        if (bodyPadding === null) return;
        document.body.style.paddingRight = bodyPadding;
        bodyPadding = null;
      });
    }

    /* 1. titel */
    function fixTitle(r) {
      var t = r.querySelector('.cart-draw__title');
      if (!t) return;
      /* Antallet stylistisk trimmes i CSS. Vi maa IKKE fjerne <info-content>,
         temaets cart-components skriver direkte i den og kaster ellers en
         fejl der stopper hele kurv-renderingen. Derfor roerer vi kun
         tekst-noderne, aldrig element-boernene. */
      var text = null;
      for (var i = 0; i < t.childNodes.length; i++) {
        var n = t.childNodes[i];
        if (n.nodeType === 3) {
          if (!text && n.nodeValue.trim()) text = n;
          else if (n !== text) n.nodeValue = '';
        }
      }
      if (!text) {
        text = document.createTextNode('');
        t.insertBefore(text, t.firstChild);
      }
      if (text.nodeValue.trim() !== CFG.title) text.nodeValue = CFG.title;
    }

    /* 2. fri fragt: egen pill-bar der fylder op med kurvens vaerdi.
       Tal: temaets <free-shipping-bar> holder value (kurv i cents) og
       minimum-value (threshold pr. marked). Vi laeser dem og formaterer
       selv efter window.theme.money_format. */
    function fmtMoney(cents) {
      return window.twrdFormatMoney(cents);
    }

    var shipState = { unlocked: null, animatedOnce: false };

    function fixShipping(r) {
      var fb = r.querySelector('free-shipping-bar');
      if (!fb) return;

      /* Taersklen og totalen kommer fra de samme to kilder som kurv-raekken:
         den ene resolver og det ene total-lager. Bjaelkens egne attributter
         er reserven. Foer dette laeste striben kun attributterne, og
         observeren her ser kun childList/subtree, aldrig en attribut-aendring.
         Derfor stod striben eet skridt bagud efter hver maengde-aendring og
         kunne sige "unlocked", mens raekken sagde "363 kr away". */
      var minimum = 0;
      try {
        var fs = window.twrdFreeShipping;
        var res = (fs && typeof fs.resolve === 'function') ? fs.resolve() : null;
        if (res && res.enabled) minimum = res.thresholdCents;
      } catch (e) {}
      if (!minimum) {
        minimum = Number(fb.minimumValue != null ? fb.minimumValue : fb.getAttribute('minimum-value'));
      }

      var value = NaN;
      try {
        var shared = window.twrdCartTotal;
        var total = (shared && typeof shared.get === 'function') ? shared.get() : null;
        if (typeof total === 'number') value = total;
      } catch (e) {}
      if (isNaN(value)) {
        value = Number(fb.value != null ? fb.value : fb.getAttribute('value'));
      }
      if (!minimum || isNaN(value)) return;

      var ui = fb.querySelector('.twrd-ship');
      if (!ui) {
        ui = document.createElement('div');
        ui.className = 'twrd-ship';
        ui.setAttribute('role', 'status');
        ui.setAttribute('aria-live', 'polite');
        ui.innerHTML =
          '<div class="twrd-ship__row">' +
            '<span class="twrd-ship__text">' + CHECK + '<span class="twrd-ship__label"></span></span>' +
            '<span class="twrd-ship__meta"></span>' +
          '</div>' +
          '<div class="twrd-ship__track" aria-hidden="true"><div class="twrd-ship__fill"></div></div>';
        fb.appendChild(ui);
      }

      var pct = Math.max(0, Math.min(100, value / minimum * 100));
      var unlocked = value >= minimum;
      var label = ui.querySelector('.twrd-ship__label');
      var meta = ui.querySelector('.twrd-ship__meta');
      var track = ui.querySelector('.twrd-ship__track');
      var fill = ui.querySelector('.twrd-ship__fill');

      var text = unlocked
        ? 'Free shipping unlocked'
        : 'Add <b>' + fmtMoney(minimum - value) + '</b> more for free shipping';
      if (label.innerHTML !== text) label.innerHTML = text;
      var metaText = fmtMoney(value) + ' / ' + fmtMoney(minimum);
      if (meta.textContent !== metaText) meta.textContent = metaText;
      ui.classList.toggle('is-unlocked', unlocked);

      /* Bevidst width og ikke scaleX: fyldet har en rund ende og en
         glans-stribe. En vandret skalering ville trykke begge sammen, og
         fragtbjaelken er et laast designelement. */
      var target = pct.toFixed(2) + '%';
      if (!shipState.animatedOnce) {
        /* foerste render: fra 0 til aktuel vaerdi */
        shipState.animatedOnce = true;
        fill.style.width = '0%';
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { fill.style.width = target; });
        });
      } else if (fill.style.width !== target) {
        fill.style.width = target;
      }

      /* kort pulse naar vi rammer 100 procent, kun ved overgangen */
      if (shipState.unlocked === false && unlocked) {
        track.classList.remove('is-pulse');
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { track.classList.add('is-pulse'); });
        });
        setTimeout(function () { track.classList.remove('is-pulse'); }, 450);
      }
      shipState.unlocked = unlocked;
    }

    /* 3. variant paa en linje: "Black / S / FRONT PRINT" -> "Black · S · Front print" */
    function fixVariants(r) {
      /* kun selve vaerdi-elementet, aldrig foraelderen, ellers sletter vi
         temaets egne child-elementer og braekker cart-store opdateringer */
      r.querySelectorAll('cart-item-default-property .cart-item__meta').forEach(function (el) {
        if (el.dataset.twrdVar) return;
        var raw = el.textContent.trim();
        if (!raw || raw.indexOf('/') === -1) return;
        el.dataset.twrdVar = '1';
        el.textContent = raw.split('/').map(function (part) {
          var s = part.trim();
          if (!s) return '';
          if (s.length <= 3) return s.toUpperCase();
          return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
        }).filter(Boolean).join(' · ');
      });
    }

    /* 4. est. delivery som foerste linje i vaerdi-boksen (information, ikke knap) */
    function fixEta(r) {
      var row = r.querySelector('.twrd-cart-values__row--eta');
      if (!row || !window.TWRDDelivery) return;
      var sch = window.TWRDDelivery.schedule({});
      if (!sch || !sch.deliveredText) return;
      var text = 'Est. delivery ' + sch.deliveredText;
      var span = row.querySelector('span');
      if (span && span.textContent !== text) span.textContent = text;
      row.classList.add('is-ready');
    }

    /* 5. rabatkode. Tertiaer: tekst-link der folder et inline-felt ud.
       Koden haenges paa checkout-URL'en, som Shopify accepterer. */
    function fixDiscount(r) {
      var details = r.querySelector('.cart__order-details');
      var values = r.querySelector('.twrd-cart-values');
      if (!details || !values || r.querySelector('.twrd-cart-discount')) return;

      var wrap = document.createElement('div');
      wrap.className = 'twrd-cart-discount';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'twrd-cart-discount__btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = TAG;
      var bl = document.createElement('span');
      bl.className = 'twrd-cart-discount__label';
      bl.textContent = 'Discount code';
      btn.appendChild(bl);
      var bc = document.createElement('span');
      bc.className = 'twrd-cart-discount__cta';
      bc.textContent = 'Add';
      btn.appendChild(bc);

      var field = document.createElement('div');
      field.className = 'twrd-cart-discount__field';
      var input = document.createElement('input');
      input.type = 'text';
      input.placeholder = 'Discount code';
      input.autocomplete = 'off';
      input.setAttribute('aria-label', 'Discount code');
      var apply = document.createElement('button');
      apply.type = 'button';
      apply.className = 'twrd-cart-discount__apply';
      apply.textContent = 'Apply';
      field.appendChild(input);
      field.appendChild(apply);

      var note = document.createElement('p');
      note.className = 'twrd-cart-discount__note';
      note.hidden = true;

      wrap.appendChild(btn);
      wrap.appendChild(field);
      wrap.appendChild(note);
      values.parentNode.insertBefore(wrap, values.nextSibling);

      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) input.focus();
      });

      function save() {
        var code = input.value.trim();
        if (!code) return;
        try { sessionStorage.setItem('twrdDiscount', code); } catch (e) {}
        note.hidden = false;
        note.textContent = code.toUpperCase() + ' will be applied at checkout';
      }
      apply.addEventListener('click', save);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); save(); } });
      /* gem allerede indtastet kode ved rerender */
      var saved = '';
      try { saved = sessionStorage.getItem('twrdDiscount') || ''; } catch (e) {}
      if (saved) { input.value = saved; note.hidden = false; note.textContent = saved.toUpperCase() + ' will be applied at checkout'; }
    }

    /* Checkout: send koden med i URL'en. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.cart__checkout') : null;
      if (!btn) return;
      var code = '';
      try { code = sessionStorage.getItem('twrdDiscount') || ''; } catch (err) {}
      if (!code) return;
      e.preventDefault();
      /* Markeder og sprog ligger i en sti-praefiks (fx /en-dk). Et haardkodet
         /checkout ville sende kunden ud af sit marked. */
      var base = '';
      try {
        base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      } catch (err) {
        base = '/';
      }
      if (base.charAt(base.length - 1) !== '/') base += '/';
      window.location.href = base + 'checkout?discount=' + encodeURIComponent(code);
    }, true);

    /* TWRD 2026-10-14 legal: "Free" only when the bag is over the threshold.
       Same sources as the shipping bar: twrdFreeShipping.resolve() and
       twrdCartTotal. Below it: "Free over X". No promise in the market:
       "Calculated at checkout". */
    function shipValue(r) {
      var el = r.querySelector('[data-twrd-ship-value]');
      if (!el) return;
      var res = null, total = null;
      try {
        var fs = window.twrdFreeShipping;
        res = (fs && typeof fs.resolve === 'function') ? fs.resolve() : null;
      } catch (e) {}
      try {
        var shared = window.twrdCartTotal;
        total = (shared && typeof shared.get === 'function') ? shared.get() : null;
      } catch (e) {}
      var fb = r.querySelector('free-shipping-bar');
      if (typeof total !== 'number' && fb) {
        var v = Number(fb.value != null ? fb.value : fb.getAttribute('value'));
        if (!isNaN(v)) total = v;
      }
      var text = 'Calculated at checkout';
      if (res && res.enabled && res.thresholdCents > 0) {
        text = (typeof total === 'number' && total >= res.thresholdCents)
          ? 'Free'
          : 'Free over ' + fmtMoney(res.thresholdCents);
      }
      if (el.textContent !== text) el.textContent = text;
    }

    /* 6. vaerdi-linjer (est. delivery foerst) + Total + note */
    function fixValues(r) {
      var details = r.querySelector('.cart__order-details');
      if (!details) return;
      if (!r.querySelector('.twrd-cart-values')) {
        var box = document.createElement('div');
        box.className = 'twrd-cart-values';

        var eta = document.createElement('div');
        eta.className = 'twrd-cart-values__row twrd-cart-values__row--eta';
        eta.innerHTML = TRUCK;
        eta.appendChild(document.createElement('span'));
        box.appendChild(eta);

        CFG.values.forEach(function (row) {
          var line = document.createElement('div');
          line.className = 'twrd-cart-values__row';
          line.innerHTML = CHECK;
          var t = document.createElement('span');
          t.textContent = row[0];
          var f = document.createElement('span');
          f.className = 'twrd-cart-values__free';
          f.textContent = row[1];
          if (row[2] === 'ship') f.setAttribute('data-twrd-ship-value', '');
          line.appendChild(t);
          line.appendChild(f);
          box.appendChild(line);
        });
        details.insertBefore(box, details.firstChild);
      }
      var total = r.querySelector('.cart__total > span');
      if (total && total.textContent.trim() !== 'Subtotal') total.textContent = 'Subtotal';
      var msg = r.querySelector('.cart__message');
      if (msg && !msg.dataset.twrdMsg) {
        msg.dataset.twrdMsg = '1';
        /* En linje under subtotalen. Moms-noten er lovpligtig i EU og staar
           foerst. Told-noten er lagt ind i samme saetning, saa bunden ikke
           vokser med endnu et afsnit. Liquid-noten i cart-details skjules
           i draweren, men bliver staaende paa kurv-siden. */
        msg.textContent = TAX_NOTE + '. Made to order, ships in 2 to 3 working days.' + (DUTY_NOTE ? ' ' + DUTY_NOTE : '');
      }
    }

    /* 7. tom bag: lookbook-billede, manifest-linje, to knapper og
       tre kort fra most-worn. Markup'en er rendret i Liquid af
       snippets/twrd-cart-empty.liquid og ligger skjult paa siden.
       Vi flytter en klon ind i temaets .cart-empty. Temaets egen
       titel og "Continue shopping" forsvinder med den. */
    function fixEmpty(r) {
      var box = r.querySelector('.cart-empty');
      if (!box || box.dataset.twrdEmpty === '1') return;
      var src = document.querySelector('#twrd-cart-empty-source .twrd-empty');
      if (!src) return;
      box.dataset.twrdEmpty = '1';
      box.textContent = '';
      box.appendChild(src.cloneNode(true));
    }

    /* 8. anbefalinger: egen overskrift, ingen "Quick view". Titlen kommer
       fra en theme-setting, saa vi skriver den om i stedet for at bede om
       en editor-aendring. */
    function fixRecs(r) {
      var title = r.querySelector('.cart-recommendations__title-text');
      if (title && title.textContent.trim() !== REC_TITLE) title.textContent = REC_TITLE;
      /* Korttitel = motivet alene. Resten af produkttitlen (farve/edition)
         bliver en mute metalinje under, som paa varelinjen. */
      r.querySelectorAll('[cart-recommendations-content] .product-card--mini').forEach(function (card) {
        if (card.dataset.twrdRec === '1') return;
        var t = card.querySelector('product-card-title') || card.querySelector('.product-card__title');
        if (!t) return;
        card.dataset.twrdRec = '1';
        var raw = (t.textContent || '').trim();
        if (raw.indexOf('·') === -1) return;
        var parts = raw.split('·');
        var motif = parts.shift().trim();
        var rest = parts.join('·').trim();
        if (!motif) return;
        t.textContent = motif;
        if (rest) {
          var h = card.querySelector('.product-card__title');
          var meta = document.createElement('span');
          meta.className = 'twrd-rec-meta';
          meta.textContent = rest;
            /* Skriftstedet er rendret i Liquid lige under titlen
             (snippets/product-card-mini.liquid). Meta-linjen skal ligge
             UNDER det, saa raekkefoelgen er motiv / vers / meta, som paa
             kollektionskortet. */
          var anchor = card.querySelector('.twrd-rec-verse') || h;
          if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(meta, anchor.nextSibling);
        }
      });
    }

    /* 9. varelinjens titel er motivet alene. Produkttitlen er
       "KING OF KINGS · BLACK & WHITE"; farven hoerer hjemme i meta-linjen
       under den, saa titlen holder sig paa en linje. */
    function fixLineTitles(r) {
      r.querySelectorAll('.cart__items cart-item-title').forEach(function (el) {
        var raw = (el.textContent || '').trim();
        if (!raw || raw.indexOf('·') === -1) return;
        var motif = raw.split('·')[0].trim();
        if (motif && motif !== raw) el.textContent = motif;
      });
    }

    /* Remove som tekst-link. Ikonet er dekorativt, teksten maales rigtigt. */
    function fixRemove(r) {
      r.querySelectorAll('a[cart-item-remove]').forEach(function (a) {
        if (a.classList.contains('twrd-remove') && a.textContent.trim() === 'Remove') return;
        a.classList.add('twrd-remove');
        a.textContent = 'Remove';
      });
    }

    /* 10. bunden maa kun baere vaerdi-raekken, CHECK OUT og ikonerne.
       Resten af cart-details (est. delivery, rabatkode, subtotal og noten)
       flyttes ned i scrolleren, foran anbefalingerne, som en kompakt
       opsummering. Draweren rerenderes af Section Rendering API, saa en ny
       .cart__details dukker op i .cart__controls igen. Derfor flytter vi
       hver gang og rydder den gamle vaek. */
    function fixSummary(r) {
      var contents = r.querySelector('cart-contents');
      if (!contents) return;
      var fresh = r.querySelector('.cart__controls .cart__details');
      if (!fresh) return;
      var moved = contents.querySelector('.cart__details');
      if (moved && moved !== fresh) moved.parentNode.removeChild(moved);
      fresh.classList.add('twrd-cart-summary');
      contents.insertBefore(fresh, contents.querySelector('cart-recommendations'));
    }

    function apply() {
      var r = root();
      if (!r) return;
      fixSummary(r);
      fixRemove(r);
      fixLineTitles(r);
      fixTitle(r);
      fixShipping(r);
      fixVariants(r);
      fixValues(r);
      shipValue(r);
      fixEta(r);
      fixDiscount(r);
      fixRecs(r);
      fixEmpty(r);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', apply);
    } else {
      apply();
    }
    /* Draweren rerenderes af cart-store ved add, remove og quantity.
       VIGTIGT: apply() skriver selv i DOM'en, saa observeren skal kobles fra
       imens. Ellers udloeser vores egne aendringer et uendeligt loop. */
    var scheduled = false;
    function scheduleApply() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        safeApply();
      });
    }
    var mo = new MutationObserver(scheduleApply);

    function safeApply() {
      var r = root();
      if (!r) return;
      mo.disconnect();
      try { apply(); } catch (e) {}
      mo.observe(r, { childList: true, subtree: true });
    }

    /* Draweren ligger i layoutet, saa den er der normalt med det samme.
       Vi proever i hoejst 20 sekunder og giver saa op, i stedet for at
       polle resten af sessionen. */
    var waits = 0;
    function observe() {
      if (root()) safeApply();
      else if (++waits <= 50) setTimeout(observe, 400);
    }
    observe();
    /* twrd-delivery-dates.js er deferred: koer igen naar den er landet,
       ellers mangler est. delivery-bjaelken indtil kurven aendrer sig. */
    if (document.readyState === 'complete') safeApply();
    else window.addEventListener('load', safeApply);
    document.addEventListener('cart:refresh', scheduleApply);
    document.addEventListener('cart:updated', scheduleApply);
    /* on:cart:loaded er den begivenhed der BAERER den nye kurv. Uden den her
       tegnede striben sig igen, foer totalen var skiftet, og blev staaende
       med det gamle tal indtil naeste aendring. */
    document.addEventListener('on:cart:loaded', scheduleApply);
    /* assets/twrd-cart-lines.js afstemmer linjelisten med /cart.js og siger
       til naar den har bygget eller fjernet en linje. Kroge som fixRemove,
       fixLineTitles og fixSummary skal ramme de nye linjer ogsaa. */
    document.addEventListener('twrd:cart-lines', scheduleApply);
  })();
